import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, filter, map } from 'rxjs/operators';
import { Action } from 'redux';
import { GetTracks } from '../action-creators';
import AppState from '../../state';
import { GetAssetStatusSuccess } from '../../assets/action-creators';
import { GET_ASSET_STATUS_SUCCESS } from '../../assets/actions';

export const getTracksAfterACRValidationEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, GetAssetStatusSuccess>(GET_ASSET_STATUS_SUCCESS),
    withLatestFrom(state$),
    filter(
      ([action, state]) =>
        !!state.release.release?.id && action.results.some((t) => t.acrDone)
    ),
    map(([_action, state]) => {
      return new GetTracks(state.release.release?.id as string);
    })
  );
